export const headCellChipProductInSite = [
  { id: "id", disablePadding: false, label: "Id" },
  { id: "chipType", disablePadding: false, label: "Tipo de chip" },
  { id: "iccid", disablePadding: false, label: "Iccid" },
  { id: "price", disablePadding: false, label: "Precio" },
  { id: "lote", disablePadding: false, label: "Lote" },
  { id: "provider", disablePadding: false, label: "Proveedor" },
  { id: "available", disablePadding: false, label: "Agregar a carrito" },
];
